<template>
    <div 
        class="drop-down-picker"
        :style="style"
    >
        <scroll>
            <ul>
                <li 
                    class="btn-drop-down"
                    v-for="(item, index) in dropDownMenu"
                    :key="index"
                    @click.stop="clickHandle(item)"
                >{{item.text}}</li>
            </ul>
        </scroll>
    </div>
</template>

<script>
import Gikam from "../../../core/gikam-core";

document.addEventListener("click", () => {
    if (!Gikam.dropdownPicker) {
        return;
    }
    Gikam.dropdownPicker.close();
}); 

export default {
    props: {
        propTop: Number,
        propRight: Number,
        propDropDownMenu: Array,
        propHeight: Number,
    },

    computed: {
        dropDownMenu() {
            const dropDownMenu = [];
            this.propDropDownMenu.forEach(item => {
                if (item.type === 'btnGroup') {
                    item.items.forEach(list => {
                        list.type === 'button' && dropDownMenu.push(list);
                    })
                } else if (item.type === 'button'){
                    dropDownMenu.push(item);
                }
            })
            return dropDownMenu;
        },

        style() {
            return 'top :' + this.top + 'px; right : ' + this.right + 'px; height : ' + this.propHeight + 'px;';
        }
    },

    inject: {
        dropdown: {
            default: null
        }
    },

    data() {
        return {
            top: this.propTop,
            right: this.propRight,
        };
    },

    mounted() {
        Gikam.dropdownPicker = this;
    },

    methods: {
        clickHandle(item) {
            item.onClick && item.onClick();
            this.dropdown.cleanPicker();
        }
    }

}
</script>

<style scoped>
.drop-down-picker{
    position: absolute;
    width: 108px;
    padding: 8px 0;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
}

.drop-down-picker ul {
    list-style: none;
    margin: 0;
    padding: 0;
    background-color: white;
    min-height: 30px;
}

.drop-down-picker ul li {
    height: 30px;
    font-family: "Microsoft YaHei", serif;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.65);
    display: flex;
    align-items: center;
    padding: 0 8px;
    cursor: pointer;
    white-space: nowrap;
}

.drop-down-picker ul li:hover {
    background: #eee;
}


</style>